import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=2eeef166&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeef166",
  null
  
)

export default component.exports